<template>
  <!--    续班 -->
  <div id="renewClass">
    <div class="renewClass-content">
      <div class="renewClass-item-box">
        <div class="left-box">单价</div>
        <div class="left-right single-price">
          ￥
          <span>{{day_price}}</span>/人/天
        </div>
      </div>
      <div class="renewClass-item-box">
        <div class="left-box">
          班级名称
        </div>
        <div class="left-right">
          <span>{{stu_name}}</span>
        </div>
      </div>
      <div class="renewClass-item-box select-stu-box">
        <div class="left-box">
          选择学生
        </div>
        <div class="left-right ">
          <p class="select-stu-p">已选 <span>{{student_check_list.length}}</span>人</p>
          <div class="select-student-list">
            <el-checkbox
              class="student-lable-item"
              size="small"
              border
              v-for="(item,index) in class_stu_list"
              :key="index"
              :value="item.check"
              @change="change_student_list(item,index)"
            >{{item.username}}</el-checkbox>
          </div>
        </div>
      </div>
      <div class="renewClass-item-box">
        <div class="left-box">
          新增学生
        </div>
        <div class="left-right">
          <div class="stu-num">
            <div class="del-btn" @click="decreaseNumber"></div>
            <el-input
              placeholder
              type="number"
              :min="1"
              :max="1000"
              v-model="stu_number"
              @input="optionLengthChange"
              @blur="optionLengthBlur"
              onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
            ></el-input>
            <div class="add-btn" @click="addNumber"></div>
          </div>
          <span class="danwei">个</span>
        </div>
      </div>
      <div class="renewClass-item-box">
        <div class="left-box">
          <i>*</i>有效日期
        </div>
        <div class="left-right">
          <div class="date-picker-box">
            <i></i>
            <el-date-picker
              format="yyyy.MM.dd"
              popper-class="renew-class-pick"
              v-model="class_time"
              type="daterange"
              range-separator="~"
              start-placeholder="选择日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions2"
              @change="filter_date"
            ></el-date-picker>
          </div>

          <p class="empty-data-tips" v-if="is_empty_date">有效日期不能为空</p>
        </div>
      </div>
      <div class="renewClass-item-box" v-if="canClickSpoken">
        <div class="left-box">
          <i>*</i>选购
        </div>
        <div class="left-right">
          <el-checkbox v-model="pick_buy" @change="change_spoken_pick">口语测评功能</el-checkbox>
        </div>
      </div>
      <div class="renewClass-item-box">
        <div class="left-box">
          <i>*</i>付费方式
        </div>
        <div class="left-right pay-methods">
          <el-radio-group v-model="pay_methods" @change="change_pay_methods">
            <el-radio :label="1">老师支付</el-radio>
            <el-radio :label="2">学生支付</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="renewClass-bottom">
        <p>订单详情</p>
        <p v-if="pay_methods==1">
          共
          <span>{{((stu_number*1)+(student_check_list.length*1))}}</span>人，
          <span>{{class_time_day}}</span>天，合计￥
          <span>{{total_price}}</span>
        </p>
        <p v-else>
          共
          <span>{{((stu_number*1)+(student_check_list.length*1))}}</span>人，
          <span>{{class_time_day}}</span>天，小计￥
          <span>{{total_price}}</span>/人
        </p>
      </div>
    </div>
    <div class="dialog-footer" style="text-align:right;">
      <el-button @click="closeModal()">取 消</el-button>
      <el-button type="primary" @click="save_class_info">保存</el-button>
    </div>
<!--    <weachetPay :imgData="pay_img_data"></weachetPay>-->
    <el-dialog append-to-body @close="close_weachet" :visible.sync="imgModelShow"  width="6.3rem"  :title="dialog_title" :close-on-click-modal="can_click_model" class="manage-dialog img-show-model-dialog" >
      <weachetPay :totalAmount="total_amount" :imgData="pay_img_data" @closeModal="closeModal" :type="user_type"></weachetPay>
    </el-dialog>
    <el-dialog
            :close-on-click-modal="false"
            class="stu-list-class"
            append-to-body
            title="账号详情"
            :visible.sync="dialogVisible"
            width="4.7rem">
      <div class="stu-list-box">
        <div class="stu-id-list">
          <p>学生账号</p>
          <p v-if="stu_list_data.length>0&&stu_list_data.length>1">{{stu_list_data[0].username}}~{{stu_list_data[stu_list_data.length-1].username}}</p>
          <p v-if="stu_list_data.length>0&&stu_list_data.length==1">{{stu_list_data[0].username}}</p>
        </div>
        <div class="stu-ps-list">
          <p>初始密码</p>
          <p>{{stu_ps}}</p>
        </div>
      </div>

      <div  class="dialog-footer" style="text-align:right;">
        <el-button type="primary" @click="close_stu_list">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from "vue";
  import Vant from "vant";
  import { Notify } from 'vant';
  Vue.use(Notify);
  Vue.use(Vant);
import * as api from "./js/orderInfoApi";
import weachetPay from "./weachetPay";
import axios from 'axios'
import {getWsToken} from '@/components/interaction/indexApi.js'
export default {
  name: "renewClass",
  props: {
    singlePrice:{
      type:Object,
    },
    curClassid:{

    },
    canClickSpoken:{
      // type:Boolean,
    }
  },
  components:{
    weachetPay,//微信支付
  },
  data() {
    return {
      // stu_number:0,//新增学生数量
      pay_methods: 1, //支付方式
      pick_buy:this.canClickSpoken, //是否选购口语
      class_time_day: 0,
      stu_number: 0, //学生数量
      class_time: "", //有效日期
      day_price:0,//单价
      total_price:0,
      spoken_price:0,//口语价格
      class_stu_list:[],
      stu_name:'',
      last_student_list: [3, 2, 6], //上一次的学生id
      select_stu: [],
      student_check_list: [], //选择的学生列表
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      is_empty_date:false,
      is_empty_name:false,
      is_empty_num:false,
      cur_order_id:null,
      pay_img_data:'',
      total_amount:0,
      imgModelShow:false,
      dialog_title:'爱米云助教-支付',
      can_click_model:false,
      user_type:'tea',
      dialogVisible:false,//学生账号详情
      stu_list_data:[],//学生列表
      stu_ps:'',//学生初始密码
      has_pay_order:false,//是否支付
      cancel_stu_number:null,
      has_click_save:false,//是否点击保存
    };
  },
  methods: {
    optionLengthChange(val) {
      if (val && val > 999) {
        this.stu_number = (val.slice(0,3)*1);
      }
      if (val && val < 0) {
        this.stu_number = 0;
      }
      // this.optionLengthHasChange = true;
      this.$forceUpdate();
      this.filter_total_price();
    },
    optionLengthBlur(val) {
      if (!this.stu_number) {
        this.stu_number = 0;
      }
    },
    //保存
    save_class_info() {
      if(!this.class_time){
        this.is_empty_date =this.class_time?false:true ;
        return;
      }
      if(((this.stu_number*1) + this.class_stu_list.length)==0){
        this.$message.error("一个班级学生数量不能为0，请重新选择想要续班的学生");
        return;
      }
      if (((this.stu_number*1) + this.class_stu_list.length )>= 1000) {
        this.$message.error("一个班级学生数量不能超过999，请重新设置");
        return;
      }
      this.$loading.show();
      this.renewClass();
    },
    //取消开班
    closeModal() {
      this.total_price=0;
      this.pay_methods = 1;
      this.pick_buy = this.canClickSpoken;
      this.class_time_day= '';
      this.stu_number = 0;
      this.class_time = '';
      // this.cancel_stu_number.cancel();
      // this.$emit("onlyClose", false);
      this.$emit("closeModal", 'close');
    },
    //选择学生
    //指定批改的学生
    change_student_list(item, index) {
      //当前是否选中-》选中-》判断是否上一次指定
      if (!item.check) {
        item.check = !item.check;
        this.student_check_list.push(item.id);
      } else {
        item.check = !item.check;
        let cur_index = this.student_check_list.indexOf(item.id);
        this.student_check_list.splice(cur_index, 1);
      }
      this.filter_total_price();
    },
    //减人数
    decreaseNumber() {
      if (this.stu_number == 0) {
        return;
      }
      this.stu_number--;
      this.filter_total_price();
    },
    //减人数
    addNumber() {
      if (this.stu_number == 999) {
        return;
      }
      this.stu_number++;
      this.filter_total_price();
    },
    //计算总价
    filter_total_price() {
      if (this.pay_methods == 1) {
        this.total_price = (
          (this.stu_number*1 + this.student_check_list.length*1) *
          this.day_price *
          this.class_time_day
        ).toFixed(2);
      } else {
        this.total_price = (this.day_price * this.class_time_day).toFixed(2);
      }

      // this.total_price = Math.floor((this.stu_number*this.day_price*this.class_time_day)*100/100) ;
    },
    //天数
    filter_date(val) {
      if (!val) {
        this.class_time_day = 0;
        return;
      }
      this.class_time_day = (val[1] - val[0]) / (1000 * 60 * 60 * 24) + 1;
      this.filter_total_price();
    },
    //付款方式
    change_pay_methods(val) {
      this.filter_total_price();
    },
    //口语
    change_spoken_pick(val) {
      if(val){
        this.day_price = (this.singlePrice.price*1)+(this.singlePrice.spokenPrice*1);
      }else{
        this.day_price = this.singlePrice.price;
      }
      this.filter_total_price();
    },
    //过滤选择的日期格式
    filter_date_status(index){
      let date = this.class_time[index];
      let year = date.getFullYear();
      let month = (date.getMonth()+1)<10?('0'+(date.getMonth()+1)):(date.getMonth()+1);
      let day = date.getDate()<10?('0'+date.getDate()):date.getDate();
      return year+'-'+month+'-'+day
    },
    //添加班级接口
    renewClass(){
      api.renewClass({
        num:this.stu_number,
        start:this.filter_date_status(0),
        end:this.filter_date_status(1),
        oral:this.pick_buy?1:0,//是否包含口语
        user_pay:this.pay_methods,//支付方式
        class_id:this.curClassid,
        student_ids:this.student_check_list,
      }).then((res)=>{
        if(res.errCode==0){
          if(res.errCode==0){
            //this.$message.success(res.msg);
            this.cur_order_id = res.data.id;
            if(this.pay_methods!=2){
              this.teaWeaPay(res.data.id);
            }else {
              //this.$message.success(res.msg);
              if(this.stu_number==0){
                this.$emit('onlyClose');
                this.$loading.hide();
                this.imgModelShow = false;
                this.$message.success('续班成功，请通知学生或家长至订单详情页去支付订单。');
                return;
              }
              this.has_click_save = true;
              sessionStorage.setItem('hasClickSave',this.has_click_save);
              this.dialogVisible = true;
              this.imgModelShow = false;
              this.stu_ps = res.data.default_password;
              this.stu_list_data = _.cloneDeep(res.data.new_students);
              this.$loading.hide();
            }
          }else{
           this.$message.error(res.msg)
          }
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    //获取教培班级学生列表
    getJpstudents(){
      api.getJpstudents({
        class_id:this.curClassid,
        // class_id:1654
      }).then((res)=>{
        if(res.errCode==0){
          this.student_check_list =[];
          this.stu_name = res.data.name;
          this.class_stu_list = _.cloneDeep(res.data.students);

          this.class_stu_list.forEach((item, index) => {
            item.check = false;
            res.data.default_students.forEach((del_stu)=>{
              if(del_stu.id==item.id){
                item.check = true;
                this.student_check_list.push(item.id);
              }
            });
          });
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    //微信支付
    teaWeaPay(id){
      api.teaWeaPay({
        order_id:id,
        method:'scan'
      }).then((res)=>{
        if(res.errCode==0){
          this.$loading.hide()
          this.pay_img_data =res.data.qrcode_image;
          this.total_amount = res.data.total_amount ;
          this.imgModelShow = true;
          this.$loading.hide();
          // setTimeout(()=>{
            this.getOrderInfo(id)
          // },3000)
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    getOrderInfo(id){
      if(!this.imgModelShow){
        return;
      }
      let cancelToken = axios.CancelToken; //Axios使我修改axios原型链了。
      this.cancel_stu_number = cancelToken.source(); //取消上传token
      // 创建实例时设置配置的默认值
      var instance = axios.create();

      instance.get('/api/jp-class/get-order', {
        params:{order_id:this.cur_order_id},
        cancelToken: this.cancel_stu_number.token,
        timeout:3000
      }).then(res=>{
        if(res.data.errCode==0){
          this.stu_ps = res.data.data.default_password;
          this.stu_list_data = _.cloneDeep(res.data.data.new_students);
          this.has_pay_order = res.data.data.is_paid;
          if(!res.data.data.is_paid){
            setTimeout(()=>{
              this.getOrderInfo();
            },2000)
          }else{
            this.getWsToken_fun(this.update_interation);
            // this.update_interation();
            if(this.stu_number==0){
              this.imgModelShow = false;
              this.$emit('paySuccecc');
              return;
            }
            this.has_click_save = true;
            sessionStorage.setItem('hasClickSave',this.has_click_save);
            // this.$message.success('支付成功');
            this.dialogVisible = true;
            this.imgModelShow = false;
          }
        }

      }).catch(err=>{
        console.log(err)
      })
    },
    //更新互动
    update_interation(){
      const host = this.$cookies.get("http_ws_host");
      $.ajax({
        type: "GET",
        url: host + "/api/akdm-service/update-class-students",
        data: {
          token: this.$cookies.get("ws_token"),
          class_id:(this.$cookies.get('jp_teacher_class_id')||this.$cookies.get('class_id')),
          request_cross_domain: window.location.host,
        },
        dataType: "json",
        success: function(res) {

        },
        error: function(xhr, type) {

        }
      });
    },
    //关闭支付二维码弹窗
    close_weachet(){
      if(this.stu_number>0){
        if(this.pay_methods==2 || this.has_pay_order){
          this.dialogVisible = true;
        }
      }else{
        if(!this.has_pay_order){
          this.imgModelShow = false;
        }else{
          this.imgModelShow = false;
          this.$emit('paySuccecc');
        }
      }
    },
    //关闭学生列表弹窗
    close_stu_list(){
      this.dialogVisible = false;
      if(!this.has_pay_order){
        if(this.pay_methods==2){
          this.$message.success('续班成功，请通知学生或家长至订单详情页去支付订单。');
        }
        this.$emit('onlyClose');
      }else{
        this.$message.success('续班成功');
        this.$emit('paySuccecc');
      }
    },
  },
  beforeDestroy(){
    if(!this.cancel_stu_number){
      return;
    }
    // sessionStorage.setItem('hasClickSave',false);
    this.cancel_stu_number.cancel();
  },
  mounted() {
    sessionStorage.setItem('hasClickSave',false);
  },
  created() {
    this.has_click_save = false;
    this.total_price=0;
    this.pay_methods = 1;
    this.pick_buy = this.canClickSpoken;
    this.class_time_day= 0;
    this.stu_number = 0;
    this.class_time = '';
    sessionStorage.setItem('hasClickSave',false);
    this.$forceUpdate();
    this.getJpstudents();
    // this.getJpstudents();
  },
  watch:{
    singlePrice:{
      handler(newVal,oldVal){
        this.spoken_price = this.canClickSpoken? this.singlePrice.spokenPrice:0;
        this.day_price = ((this.singlePrice.price*1)+(this.spoken_price*1)).toFixed(2);
      },
      deep:true,
      immediate:true,
    },
    curClassid:{
      handler(newVal,oldVal){
        // if(!this.curClassid){
        //   return;
        // }
        // this.has_click_save = false;
        // this.total_price=0;
        // this.pay_methods = 1;
        // this.pick_buy = this.canClickSpoken;
        // this.class_time_day= '';
        // this.stu_number = 0;
        // this.class_time = '';
        // sessionStorage.setItem('hasClickSave',false);
        // this.$forceUpdate();
        // this.getJpstudents();
      },
      deep:true,
      // immediate:true,
    }
  }
};
</script>

<style scoped lang="scss">
#renewClass {
  height: 100%;
  position: relative;
  font-size: 0.16rem;
  /*padding:0.1rem 0.24rem 0.2rem;*/
  color: #212121;
  .renewClass-content{
    height: calc(100% - 0.6rem);
    overflow: auto;
    padding: 0.1rem 0.24rem 0.2rem;
  }
  .renewClass-item-box {
    margin-bottom: 0.16rem;
    line-height: 0.4rem;
    /*height: 0.4rem;*/
    &:first-of-type,&:nth-of-type(2){
      line-height: 0.3rem;
      height: 0.3rem;
      margin-bottom: 0.12rem;
    }
    &:nth-of-type(3){
      line-height: 0.3rem;
    }
    > div {
      display: inline-block;
      /*line-height: 0.4rem;*/
    }
    .left-box {
      width: 1rem;
      text-align: right;
      i {
        font-style: normal;
        vertical-align: middle;
        color: red;
      }
    }
    .left-right {
      vertical-align: top;
      width: calc(100% - 1.24rem);
      margin-left: 0.24rem;
      &.pay-methods {
        vertical-align: top;
      }
    }
    /*.select-stu-box{*/
    /*    vertical-align: top;*/
    /*}*/
    .el-input {
      width: 4rem;
      height: 0.36rem;
      line-height: 0.36rem;
    }
    .el-date-editor {
      width: 3.6rem;
    }
    /*/deep/.el-input__inner{*/
    /*    height: 0.36rem;*/
    /*    line-height: 0.36rem;*/
    /*}*/
    /deep/.el-input__inner {
      height: 0.34rem;
      line-height: 0.34rem;
      border: 0;
      border-radius: 0;
      text-align: center;
    }
  }
  .single-price {
    span {
      color: #f5222d;
      font-size: 0.18rem;
    }
  }
  .renewClass-bottom {
    padding: 0 0.16rem;
    line-height: 0.54rem;
    height: 0.54rem;
    background: #eff3f6;
    color: #212121;
    > p {
      display: inline-block;
      &:last-of-type {
        width: calc(100% - 0.8rem);
        text-align: right;
      }
      span {
        &:last-of-type {
          color: #f5222d;
          font-size: 0.18rem;
        }
      }
    }
  }
  /*.student-lable-item {*/
  /*  min-width: 1rem;*/
  /*  padding: 3px 8px;*/
  /*  margin: 0 0.05rem 0.1rem 0.05rem;*/
  /*  overflow: hidden;*/
  /*}*/
  .select-stu-box {
    height: auto;
    overflow: hidden;
    .left-right {
      vertical-align: top;
    }
    p{
      span{
        /*color:#027BFE;*/
        @include fz_color;
      }
    }
    .select-student-list {
      margin-top: 0.1rem;
      border: 1px solid #d8d8dd;
      padding: 0.1rem 0.1rem;
      overflow: auto;
      border-radius: 6px;
      line-height: 0.24rem;
      max-height: 2.5rem;
      .el-checkbox{
        line-height: 0.32rem;
        padding: 0 0.12rem;
      }
      /deep/.el-checkbox__input{
        vertical-align: text-bottom;
      }
      /deep/.el-checkbox__inner{
        width: 0.16rem;
        height: 0.16rem;
        &::after{
          left:5px;
          top:2px;
          width: 3px;
          height: 7px;
          border-width: 1.5px;
        }
      }
      /deep/.el-checkbox__label{
        font-size: 0.16rem;
        padding-left: 0.06rem;
      }
    }
    .student-lable-item {
      min-width: 1rem;
      padding: 3px 8px;
      margin: 0 0.1rem 0.1rem 0;
      overflow: hidden;
    }
  }
  /*.class-name{*/
  /*    /dee/.el-input__inner{*/
  /*        height: 0.36rem;*/
  /*        line-height: 0.36rem;*/
  /*    }*/
  /*}*/
  .stu-num {
    vertical-align: middle;
    display: inline-block;
    overflow: hidden;
    height: 0.36rem;
    background: #eff3f6;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    .el-input {
      float: left;
      width: 0.66rem;
      height: 0.34rem;
      line-height: 0.34rem;
    }

    /deep/input::-webkit-outer-spin-button,
    /deep/input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
    }
    /* 火狐 */
    /deep/input {
      -moz-appearance: textfield;
    }
  }
  .del-btn,
  .add-btn {
    float: left;
    width: 0.34rem;
    height: 0.34rem;
    text-align: center;
    cursor: pointer;
  }
  .del-btn {
    border: 4px 0 0 4px;
    border-right: 1px solid #dcdfe6;
    background: url(../../../../assets/images/icon_minus_default.svg) no-repeat
      center 6px;
  }
  .add-btn {
    border-radius: 0px 4px 4px 0;
    background: url(../../../../assets/images/icon_close_default.svg) no-repeat
      center 6px;
    border-left: 1px solid #dcdfe6;
  }
  .danwei {
    padding: 0 0.1rem;
  }
  .empty-data-tips {
    line-height: 0.24rem;
    font-size: 0.12rem;
    color: #f5222d;
    font-style: normal;
    margin-left: 0.08rem;
  }
  .date-picker-box {
    display: inline-block;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 0.36rem;
    height: 0.36rem;
    vertical-align: middle;
    > i {
      display: inline-block;
      width: 0.34rem;
      height: 0.34rem;
      /*vertical-align: middle;*/
      background: #eff3f6 url(../../../../assets/images/pick-data-icon.png)
        no-repeat center;
      background-size: 50%;
    }
    /deep/.el-range-editor {
      border: 0;
      vertical-align: top;
      /deep/.el-range__icon {
        display: none;
      }
      /deep/.el-range-input {
        /*text-align:left;*/
      }
    }
  }
  @media (max-width: 980px) {
    .select-stu-box{
      .select-student-list {
        .el-checkbox{
          padding:0 0.08rem;
          margin:0  0.08rem 0.08rem 0;
          /*line-height: 0.26rem;*/
        }
        /deep/.el-checkbox__input{
          vertical-align: text-bottom;
        }
        /deep/.el-checkbox__inner{
          width: 0.16rem;
          height: 0.16rem;
          &::after{
            left: 5px;
            top: 2px;
            width: 3px;
            height: 8px;
          }
        }
        /deep/.el-checkbox__label{
          font-size: 0.14rem;
          padding-left: 0.06rem;
        }
      }
    }

  }
}
</style>
<style lang="scss">
  .renew-class-pick{
    z-index:9999!important;
  }
  .img-show-model-dialog{
    z-index: 9999!important;
  }
</style>